import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"

import i18n from "i18n"
import { API } from "api"
import { manualSubscription } from "./slice"

function* update({ payload: { userId, params, onSuccess, onError } }) {
  try {
    const response = yield call(
      API.admin.updateManualSubscription,
      userId,
      params
    )

    const { data } = response

    yield put(manualSubscription.updateCompleted())

    toastr.success(i18n.t("saved_success"))

    if (onSuccess) {
      onSuccess(data?.data)
    }
  } catch (error) {
    const errors = error.response?.data?.errors || {}
    const message = error.response?.data?.message || i18n.t("error")

    yield put(
      manualSubscription.updateRejected({
        errors,
        message,
      })
    )

    if (onError) {
      onError(errors)
    }
  }
}

function* remove({ payload: { userId, onSuccess } }) {
  try {
    yield call(API.admin.deleteManualSubscription, userId)

    yield put(manualSubscription.removeCompleted())

    toastr.success(i18n.t("subscription.removed_success"))

    if (onSuccess) {
      onSuccess()
    }
  } catch (error) {
    const errors = error.response?.data?.errors || {}
    const message = error.response?.data?.message || i18n.t("error")

    yield put(
      manualSubscription.removeRejected({
        errors,
        message,
      })
    )

    toastr.error(message)
  }
}

export function* watchUpdate() {
  yield takeEvery(manualSubscription.update, update)
}

export function* watchRemove() {
  yield takeEvery(manualSubscription.remove, remove)
}

function* manualSubscriptionSaga() {
  yield all([fork(watchUpdate), fork(watchRemove)])
}

export default manualSubscriptionSaga
